export default __webpack_public_path__ + "static/media/blub.f06568a6.svg";